import { ILayout } from '../../types/layout';
import {
    TClearLayoutAction,
    TSetLayoutAction,
} from '../../types/redux/layouts';

export const CLEAR_LAYOUT = 'CLEAR_LAYOUT';
export const SET_LAYOUT = 'SET_LAYOUT';

export const clearLayout = (layoutId: string): TClearLayoutAction => ({
    type: CLEAR_LAYOUT,
    layoutId,
});

export const setLayout = (layoutId: string, payload: ILayout): TSetLayoutAction => ({
    type: SET_LAYOUT,
    payload,
    layoutId,
});
